import { Component, ContentChild, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { AbstractControl, NonNullableFormBuilder, Validators } from '@angular/forms';
import { ConfigService, CurrentFacilityService, CustomerService } from '../../services';
import { FacilityLocationsFormGroupType } from './models/location-form';

interface ButtonTemplateRefContext {
    $implicit: FacilityLocationsFormGroupType;
}

@Component({
    selector: 'app-sprintpay-facility-locations',
    templateUrl: './facility-locations.component.html',
    styleUrls: ['./facility-locations.component.scss'],
    standalone: false,
})
export class FacilityLocationsComponent implements OnInit {
    public facility: string;
    public supportedDestinations: string[];
    public locationForm: FacilityLocationsFormGroupType;

    @ContentChild(TemplateRef) buttonTemplateRef: TemplateRef<ButtonTemplateRefContext>;

    @Output() eventOnChange = new EventEmitter<FacilityLocationsFormGroupType>();

    get location(): AbstractControl<string> | null {
        return this.locationForm.get('location');
    }

    constructor(
        private fb: NonNullableFormBuilder,
        private customerService: CustomerService,
        private currentFacilityService: CurrentFacilityService,
        private configService: ConfigService
    ) {
        this.facility = this.currentFacilityService.getFacilitySource();
        this.getSupportedDestinations();
    }

    ngOnInit(): void {
        this.createForm();
    }

    createForm(): void {
        this.locationForm = this.fb.group({
            location: ['', Validators.required],
        });
    }

    getSupportedDestinations(): void {
        const supportedDestinations = this.configService.getSupportedDestinations();
        if (supportedDestinations.length) {
            this.supportedDestinations = supportedDestinations.split(', ');
            return;
        }
        this.supportedDestinations = this.customerService.supported_destinations.split(',');
    }

    onSelectShipmentLocation(): void {
        this.eventOnChange.emit(this.locationForm);
    }
}
